export enum LoadingStatusEnum {
  NOT_LOADING = 'NOT_LOADING',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
